import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import React, { useMemo } from "react";
import ReactTableForm from "../../../../../components/Common/ReactTableForm";

const InvoiceTemplate1 = props => {
  const t = ["type", "period", "amount"];

  const notCustomColls = useMemo(() => {
    props.notCustomColls.map((i, k) => {
      return {
        ...i,
        Header: props.demo
          ? `${props.valuesTemplate?.[t[k]] || i.Header}`
          : i.Header,
      };
    });
  });

  const ClientColls = useMemo(() => {
    return props.ClientColls.map((i, k) => {
      return {
        ...i,
        Header: props.demo
          ? `${props.valuesTemplate?.[t[k]] || i.Header}`
          : i.Header,
      };
    });
  });

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h4 className="font-size-18">
            {props.langUA
              ? props.invoiceData.supplier_signer
              : props.invoiceData.supplier_name}
          </h4>
          {/* <address>{invoiceData.supplier_street}</address> */}
          <br />
          <br />
          <br />
        </Col>
        <Col xs={12} className="mt-2">
          <h4
            className="font-size-32"
            style={{ fontWeight: 600, fontSize: 34 }}
          >
            {props.demo
              ? `${props.valuesTemplate?.invoice || "Invoice"}`
              : props.langUA
                ? "Рахунок"
                : "Invoice"}{" "}
            №{props.invoiceData.number}
          </h4>
          <address style={{ fontWeight: 600, fontSize: 15 }}>
            <b style={{ fontWeight: 600 }}>
              {props.demo
                ? `${props.valuesTemplate?.date || "DATE"}`
                : props.langUA
                  ? "Від"
                  : "DATE"}
              : {props.invoiceData.date_issue}
            </b>
          </address>
        </Col>
        <Col xs={6}>
          <address className="">
            <strong>
              {props.demo
                ? `${props.valuesTemplate?.to || "TO"}`
                : props.langUA
                  ? "Платник"
                  : "TO"}
              :{" "}
            </strong>{" "}
            <br />
            <span>{props.invoiceData.customer_name}</span>
            {/* <br /> */}
            {/* <span>{props.invoiceData.customer_street}</span> */}
          </address>
        </Col>
        <Col xs={6} className="text-end">
          <address>
            <strong>
              {props.demo
                ? `${props.valuesTemplate?.bill_info ||
                `${props.langUA ? "Платіжні данні" : "Billing information"}`
                }: `
                : props.langUA
                  ? "Платіжні данні"
                  : "Billing information"}
            </strong>
            <br />
            {props.langUA
              ? props.invoiceData.supplier_signer
              : props.invoiceData.supplier_name}
            <br />
            {props.invoiceData.bank_name} {/* Bank name */}
            <br />
            {/* {props.invoiceData.bank_street} Bank address */}
            {/* <br /> */}
            {props.invoiceData.bank_account_number} {/* Account № */}
            <br />
            {props.invoiceData?.bank_edrpou &&
              `${props.langUA ? "ЄДРПОУ" : "EDRPOU"} ${props.invoiceData.bank_edrpou
              }`}
            <br />
            {props.invoiceData.bank_swift_bic} {/* SWIFT */}
          </address>
        </Col>
      </Row>
      <div style={{ paddingBottom: 40 }} />
      <Row className="mt-3">
        {props.invoiceData && (
          <ReactTableForm
            columns={
              props.classification !== "CUSTOM" &&
                props.classification !== "USER"
                ? props.demo && !props.with_signature
                  ? notCustomColls
                  : props.notCustomColls
                : props.demo && !props.with_signature
                  ? ClientColls
                  : props.ClientColls
            }
            // data={{
            //   results:
            //     props.classification !== 'CUSTOM' && props.classification !== 'USER'
            //       ? props.table_data //SalaryTable()
            //       : props.invoiceData?.items,
            // }}
            data={{
              results:
                props.classification !== "CUSTOM" &&
                  props.classification !== "USER"
                  ? props.table_data
                  : props.invoiceData?.items.map(i => {
                    return {
                      ...i,
                      custom_unit_price: props.langUA
                        ? i.custom_unit_price.split(" ")[0] + " ГРН"
                        : i.custom_unit_price,
                      date_from: props.invoiceData.date_from,
                      date_to: props.invoiceData.date_to,
                    };
                  }),
            }}
            onTableChange={props.handleChangeTable}
          />
        )}
        {props.invoiceData.show_tax && props.invoiceData?.tax_type && (
          <h6 className="m-0 text-end">
            {props.invoiceData.tax_type}: {props.invoiceData.tax_rate}%
          </h6>
        )}
        <h3 className="m-0 text-end">
          {props.langUA ? (
            <>
              До сплати:{" "}
              {props.invoiceData.show_tax ? props.grandTotalWithTax(
                props.invoiceData.total_in_the_selected_currency,
                props.invoiceData.tax_rate
              ) : props.invoiceData.total_in_the_selected_currency}
              {" "}
              {props.total_in_custom_currency?.split(" ")[1]}
            </>
          ) : (
            <>
              Grand total:{" "}
              {props.invoiceData.show_tax ? props.grandTotalWithTax(
                props.invoiceData.total_in_the_selected_currency,
                props.invoiceData.tax_rate
              ) : props.invoiceData.total_in_the_selected_currency}
              {" "}
              {props.total_in_custom_currency?.split(" ")[1]}
            </>
          )}
        </h3>
        <h4 className="m-0 text-end">
          {props.demo ? (
            `${props.valuesTemplate?.grand_total || "Grand total"}: `
          ) : props.langUA ? (
            <>
              До сплати:{" "}
              {props.invoiceData.show_tax ? props.grandTotalWithTax(
                props.invoiceData.total_in_the_selected_currency,
                props.invoiceData.tax_rate
              ) : props.invoiceData.total_in_the_selected_currency}
              {" "}
              {props.total_in_custom_currency?.split(" ")[1]}
            </>
          ) : (
            <>
              Grand total:{" "}
              {props.invoiceData.show_tax ? props.grandTotalWithTax(
                props.invoiceData.total_in_the_selected_currency,
                props.invoiceData.tax_rate
              ) : props.invoiceData.total_in_the_selected_currency}
              {" "}
              {props.total_in_custom_currency?.split(" ")[1]}
            </>
          )}
        </h4>
      </Row>
      <div className="py-2 mt-3"></div>
      <div style={{ paddingBottom: 80 }} />
      <StyledRow
        id="signature__preview_invoice"
        className="row align-items-center"
      >
        <Col xl={4} className="text-start d-flex align-items-center">
          <h5 className="ml-5">
            <span>
              {props.demo
                ? `${props.valuesTemplate?.director || "Director"}`
                : props.langUA
                  ? "Директор"
                  : "Director"}
            </span>{" "}
            {props.invoiceData.supplier_signer}
          </h5>
        </Col>
        <Col
          xl={4}
          style={{ height: 110 }}
          className="d-flex justify-content-center align-items-center"
        >
          {props.demo && !props.with_signature ? (
            props.langUA ? (
              "Підпис"
            ) : (
              "Signature"
            )
          ) : (
            <img
              id="signature__preview_image"
              src={props.base64Image || ""}
              alt="signature__preview_image"
            />
          )}
        </Col>
        <Col xl={4} className="align-items-center"></Col>
      </StyledRow>
    </React.Fragment>
  );
};

const StyledRow = styled.div`
  margin-bottom: 20px;

  img {
    width: auto;
    height: 110px;
  }

  h4 {
    margin-left: 15px;
    margin-bottom: 0;
  }
`;

InvoiceTemplate1.propTypes = {
  classification: PropTypes.any,
  table_data: PropTypes.object,
  notCustomColls: PropTypes.any,
  ClientColls: PropTypes.any,
  handleChangeTable: PropTypes.func,
  total_in_custom_currency: PropTypes.any,
  base64Image: PropTypes.any,
  invoiceData: PropTypes.object.isRequired,
  langUA: PropTypes.boolean,
  demo: PropTypes.boolean,
  valuesTemplate: PropTypes.object,
  with_signature: PropTypes.bool,
  grandTotalWithTax: PropTypes.func,
};

export default InvoiceTemplate1;
